'use strict';

var toMomentObject = require('../../../../_virtual/toMomentObject.js_commonjs-exports.js');
var interopRequireDefault = require('../../node_modules/@babel/runtime/helpers/interopRequireDefault.js');
var moment = require('moment');
require('../constants.js');
var constants = require('../../../../_virtual/constants.js_commonjs-exports.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);

(function (exports) {

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toMomentObject;

var _moment = _interopRequireDefault(moment__default["default"]);

var _constants = constants.__exports;

function toMomentObject(dateString, customFormat) {
  var dateFormats = customFormat ? [customFormat, _constants.DISPLAY_FORMAT, _constants.ISO_FORMAT] : [_constants.DISPLAY_FORMAT, _constants.ISO_FORMAT];
  var date = (0, _moment["default"])(dateString, dateFormats, true);
  return date.isValid() ? date.hour(12) : null;
}
}(toMomentObject.__exports));
